<template>
  <div class="grid" id="desgloseDeuda">
    <div class="col-12">
      <Panel :header="$t('reclamacion.detalleReclamacion.impagos')">
        <DataTable
          :loading="loading"
          :value="impagos"
          :expandedRows.sync="expandedRows"
          data-key="uuid"
          class="p-datatable-responsive"
        >
          <template #header>
            <div class="table-header-container">
              {{ $t("reclamacion.detalleReclamacion.impagos2") }}
            </div>
          </template>
          <Column :expander="true" headerStyle="width: 3rem">
            <template #header>
              <button class="p-row-toggler p-link" @click="expandOrCollapse()">
                <span :class="expandClass"></span>
              </button>
            </template>
          </Column>
          <Column
            field="referenciaCliente"
            :header="$t('expedientes.header.impagos.nReferencia')"
          >
            <template #body="slotProps">
              <span class="p-column-title">{{
                $t("expedientes.label.nReferencia")
              }}</span>
              <template v-if="slotProps.data.referenciaCliente">
                {{ slotProps.data.referenciaCliente }}
              </template>
              <template v-else>
                {{ slotProps.data.reclamacionToken }}
              </template>
            </template>
          </Column>
          <Column
            :header="$t('expedientes.header.impagos.token')"
          >
            <template #body="slotProps">
              {{ slotProps.data.reclamacionToken }}
            </template>
          </Column>
          <Column field="importe" :header="$t('impago.importe')">
            <template #body="slotProps">
              {{ slotProps.data.importe | toCurrency("es-ES", divisa) }}
            </template>
          </Column>
          <Column field="pendiente" :header="$t('impago.importePendiente')">
            <template #body="slotProps">
              {{
                totalPendientePago(slotProps.data.importe, slotProps.data.pagos)
                  | toCurrency("es-ES", divisa)
              }}
            </template>
          </Column>

          <Column field="fechaOrigen" :header="$t('impago.fechaOrigen')">
            <template #body="slotProps">
              <span v-show="slotProps.data.fechaOrigen">{{
                getFormattedDateLong(slotProps.data.fechaOrigen)
              }}</span>
            </template>
          </Column>
          <Column field="fechaAlta" :header="$t('impago.fechaAlta')">
            <template #body="slotProps">
              <span v-show="slotProps.data.fechaAlta">{{
                getFormattedDateLong(slotProps.data.fechaAlta)
              }}</span>
            </template>
          </Column>
          <Column
            field="fechaVencimiento"
            :header="$t('impago.fechaVencimiento')"
          >
            <template #body="slotProps">
              <span v-show="slotProps.data.fechaVencimiento">{{
                getFormattedDateLong(slotProps.data.fechaVencimiento)
              }}</span>
            </template>
          </Column>
          <Column field="recuperado" :header="$t('impago.recuperado')">
            <template #body="slotProps">
              {{
                slotProps.data.recuperado ? $t("common.yes") : $t("common.no")
              }}
            </template>
          </Column>
          <Column
            field="ficha"
            :header="$t('expedientes.header.ficha')"
            :sortable="false"
            bodyStyle="text-align:center"
          >
            <template #body="slotProps">
              <BotoneraAccionesImpago
                :impagoUuid="slotProps.data.uuid"
                :tokenImpago="slotProps.data.token"
                :reclamacion="slotProps.data.reclamacion"
                :importePendiente="slotProps.data.importePendiente"
                @on-action-processed="onActionProcessed"
              />
            </template>
          </Column>
          <template #expansion="slotProps">
            <div class="grid mb-2 pl-5">
              <div class="col-12 dashboard">
                <Panel
                  v-if="slotProps.data.segmento && slotProps.data.jsonSegmento !== '{}'"
                  :header="$t('operacion.detalleOperacion.segmento') + slotProps.data.segmento.nombre"
                  class="pt-2">
                  <ListaAtributos
                    :jsonSegmento="slotProps.data.jsonSegmento"
                    :key="'ListaAtributos'"
                    id="listaAtributos"
                  />
                </Panel>
              </div>
            </div>
            <div class="orders-subtable">
              <DataTable
                :value="slotProps.data.pagos"
                :header="$t('reclamacion.detalleReclamacion.labelExpansion')"
                class="
                  p-datatable-responsive
                  tableExpansion
                  expedientesDatatable
                "
                :autoLayout="true"
              >
                <template #header>
                  <span>{{
                    $t("reclamacion.detalleReclamacion.labelExpansion")
                  }}</span>
                </template>
                <template #empty>
                  {{ $t("common.noResultados") }}
                </template>
                <Column field="fechaPago" :header="$t('pagos.fechaPago')">
                  <template #body="slotProps">
                    {{ getFormattedDateLong(slotProps.data.fechaPago) }}
                  </template>
                </Column>
                <Column field="fechaAlta" :header="$t('pagos.fechaAlta')">
                  <template #body="slotProps">
                    {{ getFormattedDateLong(slotProps.data.fechaAlta) }}
                  </template>
                </Column>
                <Column field="importeRecuperado" :header="$t('pagos.importe')">
                  <template #body="slotProps">
                    {{
                      slotProps.data.importeRecuperado
                        | toCurrency("es-ES", slotProps.data.divisa)
                    }}
                  </template>
                </Column>
                <Column
                  field="observaciones"
                  :header="$t('pagos.observaciones')"
                >
                  <template #body="slotProps">
                    {{ slotProps.data.observaciones }}
                  </template>
                </Column>
                <Column field="comisiona" :header="$t('pagos.comisiona')">
                  <template #body="slotProps">
                    {{
                      slotProps.data.comisiona
                        ? $t("common.yes")
                        : $t("common.no")
                    }}
                  </template>
                </Column>
              </DataTable>
            </div>
          </template>
        </DataTable>
      </Panel>
    </div>
  </div>
</template>
<script>
import BotoneraAccionesImpago from "@/components/portal-gran-cliente/Expedientes/BotoneraAccionesImpago.vue";
import ListaAtributos from "@/components/portal-gran-cliente/altaOperacion/Segmentos/ListaAtributos.vue";

import ActionsMixin from "@/utils/actions";
import DownloadsMixin from "@/utils/downloads";
import CurrencyMixin from "@/utils/currency";
import DatesMixin from "@/utils/dates";

import { CLASS_COLLAPSED_ALL, CLASS_EXPANDED_ALL } from "@/resources/constants";

export default {
  name: "ListadoImpagosOperacion",
  mixins: [ActionsMixin, DownloadsMixin, CurrencyMixin, DatesMixin],
  components: {
    BotoneraAccionesImpago,
    ListaAtributos,
  },
  props: ["impagos"],
  data() {
    return {
      divisa: "EUR",
      displayEditarInfoBasicaPago: false,
      expandedRows: [],
      expandClass: CLASS_COLLAPSED_ALL,
      errorsFieldsEditarInfoPago: [],
      infoBasicaPago: {
        fechaPago: null,
        noComisiona: false,
        observaciones: "",
        uuidPago: null,
        filename: "",
        base64: null,
        file: null,
      },
      loading: true,
    };
  },
  methods: {
    totalPendientePago(importeImpago, pagos) {
      const totalPagos = pagos
        ? pagos.reduce((acc, pago) => {
            return acc + parseFloat(pago.importeRecuperado);
          }, 0)
        : 0;
      return parseFloat(importeImpago) - totalPagos;
    },
    modalEditarPago(pago) {
      this.$set(this.infoBasicaPago, "uuidPago", pago.uuid);
      this.$set(
        this.infoBasicaPago,
        "noComisiona",
        pago.comisiona ? false : true
      );
      this.$set(this.infoBasicaPago, "observaciones", pago.observaciones);
      this.$set(
        this.infoBasicaPago,
        "fechaPago",
        pago.fechaPago ? new Date(pago.fechaPago) : null
      );

      this.displayEditarInfoBasicaPago = true;
    },
    expandOrCollapse() {
      this.expandClass.includes("pi-chevron-right") == true
        ? this.expandAll()
        : this.collapseAll();
    },
    expandAll() {
      this.expandClass = CLASS_EXPANDED_ALL;
      this.expandedRows = this.detalleReclamacion.impagos.filter((p) => p.uuid);
    },
    collapseAll() {
      this.expandClass = CLASS_COLLAPSED_ALL;
      this.expandedRows = null;
    },
    onActionProcessed() {
      this.loading = true;
      this.$emit("on-action-processed", true);
    },
  },
};
</script>